<template>
    <div
        :class="[
            'mobile-map-overlay',
            { 'show-on-mobile': showOverlayOnMobile },
        ]"
        @click="showOverlayOnMobile = false"
    >
        <span class="icon material-symbols-outlined">travel_explore</span>
    </div>
    <span
        v-if="!showOverlayOnMobile"
        class="mobile-map-overlay-close material-symbols-outlined"
        @click="showOverlayOnMobile = true"
    >
        close
    </span>
</template>

<script>
export default {
    name: "MobileMapOverlay",
    data() {
        return {
            showOverlayOnMobile: true,
        };
    },
};
</script>
